__turbopack_context__.v({
  "file": "File-module__neDMmq__file",
  "fileButtons": "File-module__neDMmq__fileButtons",
  "fileChecked": "File-module__neDMmq__fileChecked",
});
